module.exports = negate

/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to negate
 * @returns {vec2} out
 */
function negate(out, a) {
    out[0] = -a[0]
    out[1] = -a[1]
    return out
}


//////////////////
// WEBPACK FOOTER
// ./~/gl-vec2/negate.js
// module id = 512
// module chunks = 0